import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

export function Input({ className = "", ...props }: InputProps) {
  return (
    <input
      className={`w-full px-3 py-2 bg-duvi-surface border border-duvi-border rounded-[6px] text-duvi-text-primary placeholder:text-duvi-text-muted focus:outline-none focus:border-duvi-accent transition-colors ${className}`}
      style={{ fontSize: "var(--text-sm)" }}
      {...props}
    />
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export function Textarea({ className = "", ...props }: TextareaProps) {
  return (
    <textarea
      className={`w-full px-3 py-2 bg-duvi-surface border border-duvi-border rounded-[6px] text-duvi-text-primary placeholder:text-duvi-text-muted focus:outline-none focus:border-duvi-accent transition-colors resize-none ${className}`}
      style={{ fontSize: "var(--text-sm)" }}
      {...props}
    />
  );
}
